// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"K_b8","active":"K_S","container":"K_b","principalList":"K_b9","column":"K_b2","bottom":"K_cb","left":"K_cc","author":"K_cd"};